var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-container"},[_c('div',{staticClass:"qr-box"},[_c('qrcode-vue',{staticClass:"qr-code",attrs:{"value":_vm.value,"size":_vm.size,"level":_vm.level}}),(_vm.logoSrc)?_c('img',{staticClass:"qr-logo",attrs:{"src":_vm.logoSrc,"alt":"QR Logo"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }